import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants';
import dataModel from '../../models/DataModel';
import directoriesService from '../../services/directoriesService';

export default class DirectoriesCollection extends AOCollection {
  /**
   * @param {object} filter - has the following properties:
   *  - searchString (string)
   *  - sortField (string)
   *  - ascending (boolean)
   *  - showDisabled (boolean)
   *  - companyId (number)
   *  - userType (string)
   */
  constructor(perPage, filter, userId, companyId, recordDescriptor, subKey) {
    super({
      name: ReduxConstants.DIRECTORIES,
      collectionType: ReduxConstants.DIRECTORY,
      perPage,
      filter,
      userId,
      companyId,
      recordDescriptor,
      subKey,
    });
  }
  static build(perPage, filter, userId, companyId, recordDescriptor, subKey) {
    const collection = new DirectoriesCollection(perPage, filter, userId, companyId || localStorage.current_company_id, recordDescriptor, subKey);
    const collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(pageOverride, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      else this.page++;

      const { sortField, ascending } = this._filter;
      let serviceCall = directoriesService.getDirectories.bind(this, this.page, this.perPage, sortField, ascending, options);
      let newCollection = await this._fetchData(serviceCall, options, true, null, prefetchCallback);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }

  async fetchCurrent(dummy, options = {}, prefetchCallback,) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let collection = this.findCollection();

      let page = null;
      let perPage = null;
      
      // Get everything we already got
      page = 1;
      if (collection && collection.perPage) {
        perPage = Math.max(this.perPage, collection.ids.length);
      }

      const { sortField, ascending } = this._filter;
      let serviceCall = directoriesService.getDirectories.bind(this, page, perPage, sortField, ascending, options);
      let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/DirectoriesCollection.js